import axios from 'axios'

export const BASE_URL =
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost/viralmobile/'
    : 'https://vip.viralmobilenow.com/public/') + 'api'

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? BASE_URL : 'https://vip.viralmobilenow.com/public/api',
  withCredentials: true
})
export default api
